import { omit } from 'lodash';

const initialState = {
  isSaving: false,
  atlasLocations: [],
  places: {},
  modelData: {},
};

function applyPlace(state, data) {
  const previousPlace = state.places[data.id];
  const nextPlaces = {
    ...state.places,
    [data.id]: {
      ...previousPlace,
      ...data,
    },
  };
  const modelId = data.model_id ?? previousPlace?.model_id;
  const previousModelId = previousPlace?.model_id;
  let modelData = state.modelData;
  if (previousModelId != null && previousModelId !== modelId) {
    const previousEntry = modelData[previousModelId];
    if (previousEntry) {
      modelData = {
        ...modelData,
        [previousModelId]: {
          ...previousEntry,
          placeIds: previousEntry.placeIds.filter((id) => id !== data.id),
        },
      };
    }
  }
  if (modelId == null) {
    return {
      ...state,
      places: nextPlaces,
      modelData,
    };
  }
  const existingModelData = modelData[modelId];
  const placeIds = existingModelData?.placeIds || [];
  return {
    ...state,
    places: nextPlaces,
    modelData: {
      ...modelData,
      [modelId]: {
        placeIds: placeIds.includes(data.id)
          ? placeIds
          : [...placeIds, data.id],
        id: modelId,
        reusable:
          data.reusable !== undefined
            ? data.reusable
            : existingModelData?.reusable,
        fileName:
          data.name !== undefined ? data.name : existingModelData?.fileName,
        textures:
          data.textures !== undefined
            ? data.textures || {}
            : existingModelData?.textures ?? {},
        png_transparency_enabled:
          data.png_transparency_enabled !== undefined
            ? data.png_transparency_enabled
            : existingModelData?.png_transparency_enabled,
      },
    },
  };
}

const places = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'PLACE_SAVING': {
      return {
        ...state,
        isSaving: !state.isSaving,
      };
    }
    case 'SAVE_PLACES': {
      return action.data.reduce(
        (nextState, place) => applyPlace(nextState, place),
        state
      );
    }
    case 'SAVE_PLACE': {
      return applyPlace(state, action.data);
    }
    case 'DELETE_PLACE': {
      const entry = state.modelData[action.modelId];
      return {
        ...state,
        places: omit(state.places, action.id),
        modelData: entry
          ? {
              ...state.modelData,
              [action.modelId]: {
                ...entry,
                placeIds: entry.placeIds.filter((id) => id !== action.id),
              },
            }
          : state.modelData,
      };
    }
    case 'SAVE_ATLAS_LOCATIONS': {
      return {
        ...state,
        atlasLocations: action.data,
      };
    }
    default:
      return state;
  }
};

export default places;
